import { render, staticRenderFns } from "./AddExpectedTransaction.vue?vue&type=template&id=196109ae"
import script from "./AddExpectedTransaction.vue?vue&type=script&lang=js"
export * from "./AddExpectedTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports